import { render, staticRenderFns } from "./CanvasBaseMap.vue?vue&type=template&id=f56c4cd0&scoped=true&"
import script from "./CanvasBaseMap.vue?vue&type=script&lang=js&"
export * from "./CanvasBaseMap.vue?vue&type=script&lang=js&"
import style0 from "./CanvasBaseMap.vue?vue&type=style&index=0&id=f56c4cd0&scoped=true&lang=css&"
import style1 from "./CanvasBaseMap.vue?vue&type=style&index=1&id=f56c4cd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56c4cd0",
  null
  
)

export default component.exports